/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { ValidationResult, BlobRef } from '@atproto/lexicon'
import { isObj, hasProp } from '../../../../util'
import { lexicons } from '../../../../lexicons'
import { CID } from 'multiformats/cid'
import * as ComAtprotoRepoStrongRef from '../../../com/atproto/repo/strongRef'

export interface Record {
  /** The actionId from v1 */
  actionId: string
  collectionId: string
  createdAt: string
  /** Unique Id for payment if payment was required */
  paymentId?: string
  /** The wallet address the collectible was sent to */
  wallet: string
  subject?: ComAtprotoRepoStrongRef.Main
  postSubject?: ComAtprotoRepoStrongRef.Main
  [k: string]: unknown
}

export function isRecord(v: unknown): v is Record {
  return (
    isObj(v) &&
    hasProp(v, '$type') &&
    (v.$type === 'app.bsky.splx.claim#main' ||
      v.$type === 'app.bsky.splx.claim')
  )
}

export function validateRecord(v: unknown): ValidationResult {
  return lexicons.validate('app.bsky.splx.claim#main', v)
}
